import { useContext } from 'react';
import { NotesContext } from '../contexts/NotesContextProvider';

const useNotesContainer = () => {
  const { getPendingNoteById, handleAddNote, handleRemoveNote, handleRetry, handleUpdateNote, notesPending } =
    useContext(NotesContext);

  return {
    getPendingNoteById,
    handleAddNote,
    handleRemoveNote,
    handleRetry,
    handleUpdateNote,
    notesPending,
  };
};

export default useNotesContainer;
